<template>
  <div class="page-content" />
</template>

<script>
export default {
  name: 'none'
};
</script>

<style lang="scss" scoped>
@import 'src/assets/style/common';
@import 'src/assets/style/none';
</style>



// WEBPACK FOOTER //
// None.vue?04684250